import React from 'react';
import { motion } from 'framer-motion';

export const ResizeDragOverlay = ({ drag, liveVal }) => {
  if (!drag) return null;
  
  const isX = drag.type === 'paddingXLeft' || drag.type === 'paddingXRight';
  const isY = drag.type === 'fontSizeTop' || drag.type === 'fontSizeBottom';
  const isImageWidth = drag.type === 'imageWidth';
  const isImageHeight = drag.type === 'imageHeight';
  
  let label = '';
  if (isX) label = `Width Padding: ${liveVal}px`;
  else if (isY) label = `Font Size: ${liveVal}px`;
  else if (isImageWidth) label = `Image Width: ${liveVal}%`;
  else if (isImageHeight) label = `Image Height: ${liveVal}px`;
  
  const overlayColor = isX ? 'rgba(251,191,36,0.10)' : isImageWidth || isImageHeight ? 'rgba(59,130,246,0.10)' : 'rgba(236,72,153,0.10)';
  const borderColor = isX ? 'rgba(251,191,36,0.5)' : isImageWidth || isImageHeight ? 'rgba(59,130,246,0.5)' : 'rgba(236,72,153,0.5)';
  const pillBg = isX ? '#f59e0b' : isImageWidth || isImageHeight ? '#3b82f6' : '#ec4899';
  const cursorClass = isX || isImageWidth ? 'cursor-ew-resize' : 'cursor-ns-resize';
  
  return (
    <div className={`fixed inset-0 z-[200] flex items-center justify-center pointer-events-auto ${cursorClass}`} style={{ backgroundColor: overlayColor, border: `2px solid ${borderColor}`, backdropFilter: 'blur(1px)' }}>
      {(isX || isImageWidth) && (
        <>
          <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-[1px] opacity-30" style={{ background: `linear-gradient(to right, transparent, ${pillBg}, transparent)` }} />
          <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[1px] opacity-20" style={{ backgroundColor: pillBg }} />
        </>
      )}
      {(isY || isImageHeight) && (
        <>
          <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[1px] opacity-30" style={{ background: `linear-gradient(to bottom, transparent, ${pillBg}, transparent)` }} />
          <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-[1px] opacity-20" style={{ backgroundColor: pillBg }} />
        </>
      )}
      <motion.div key={liveVal} initial={{ scale: 0.85, opacity: 0.6 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: 'spring', stiffness: 400, damping: 25 }} className="flex flex-col items-center space-y-2 select-none">
        <div className="text-[10px] font-black uppercase tracking-[0.25em] text-white/70">
          {isX ? '◀  Drag to adjust width  ▶' : isImageWidth ? '◀  Drag to adjust image width  ▶' : isImageHeight ? '▲  Drag to adjust image height  ▼' : '▲  Drag to adjust size  ▼'}
        </div>
        <div className="px-8 py-4 rounded-2xl shadow-2xl font-black text-white flex items-baseline space-x-1" style={{ backgroundColor: pillBg, fontSize: '2.5rem', minWidth: '180px', textAlign: 'center', justifyContent: 'center', boxShadow: `0 0 40px ${pillBg}60` }}>
          <span>{liveVal}</span>
          <span className="text-lg opacity-70">{isImageWidth ? '%' : 'px'}</span>
        </div>
        <div className="text-[11px] font-bold text-white/60">{label}</div>
      </motion.div>
    </div>
  );
};